var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-table',{attrs:{"size":_vm.tableSize,"rowKey":"id","columns":_vm.columns,"data-source":_vm.followList,"pagination":false,"bordered":_vm.tableBordered,"scroll":{ x: 500}}})
}
var staticRenderFns = []

export { render, staticRenderFns }